import { render } from "./faq-item.vue?vue&type=template&id=3d34519c&scoped=true&ts=true"
import script from "./faq-item.vue?vue&type=script&lang=ts"
export * from "./faq-item.vue?vue&type=script&lang=ts"

import "./faq-item.vue?vue&type=style&index=0&id=3d34519c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d34519c"]])

export default __exports__